<template>
	<a class="no-default-style block relative select-none"
     :class="{'zt-hover cursor-pointer' : league_id === 4 && match.localteam_team_query_name && match.visitorteam_team_query_name}"
     @click="handleClick(league_id === 4 && match.localteam_team_query_name && match.visitorteam_team_query_name ?
      `/wyniki-pilka-nozna/porownanie-druzyn/${match.localteam_team_query_name}/${match.visitorteam_team_query_name}/` : null, '_self')">
		<div class="absolute h-[16px] -top-5 overflow-hidden w-full bg-zt-light rounded-zt text-xs flex justify-center
		            items-center font-semibold gap-x-[3px]" v-if="variant === 'final'">
			<span>
				FINAŁ
			</span>
			<svg class="inline" width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_22358_39385)">
					<path d="M8.7 1.5H7.38353C7.44952 1.1031 7.48843 0.702179 7.5 0.3C7.50002 0.260597 7.49228 0.221576 7.47721 0.185168C7.46214 0.148761 7.44004 0.11568 7.41218 0.0878179C7.38432 0.0599558 7.35124 0.0378589 7.31483 0.0227904C7.27842 0.00772196 7.2394 -2.24301e-05 7.2 4.87951e-08H1.8C1.7606 -2.24301e-05 1.72158 0.00772196 1.68517 0.0227904C1.64876 0.0378589 1.61568 0.0599558 1.58782 0.0878179C1.55996 0.11568 1.53786 0.148761 1.52279 0.185168C1.50772 0.221576 1.49998 0.260597 1.5 0.3C1.51157 0.702179 1.55048 1.1031 1.61647 1.5H0.3C0.260597 1.49998 0.221576 1.50772 0.185168 1.52279C0.148761 1.53786 0.11568 1.55996 0.0878179 1.58782C0.0599558 1.61568 0.0378589 1.64876 0.0227904 1.68517C0.00772196 1.72158 -2.24301e-05 1.7606 4.87951e-08 1.8V3C0.00222181 3.47252 0.106638 3.93897 0.306083 4.36735C0.505529 4.79572 0.795284 5.17588 1.15547 5.48174C1.57331 5.83586 2.10191 6.03258 2.6496 6.0378C2.71224 6.0378 2.7751 6.03384 2.83798 6.0285C3.00963 6.446 3.23421 6.83973 3.5062 7.2H3C2.9606 7.19998 2.92158 7.20772 2.88517 7.22279C2.84876 7.23786 2.81568 7.25996 2.78782 7.28782C2.75996 7.31568 2.73786 7.34876 2.72279 7.38517C2.70772 7.42158 2.69998 7.4606 2.7 7.5V8.7C2.69998 8.7394 2.70772 8.77842 2.72279 8.81483C2.73786 8.85124 2.75996 8.88432 2.78782 8.91218C2.81568 8.94004 2.84876 8.96214 2.88517 8.97721C2.92158 8.99228 2.9606 9.00002 3 9H6C6.0394 9.00002 6.07842 8.99228 6.11483 8.97721C6.15124 8.96214 6.18432 8.94004 6.21218 8.91218C6.24004 8.88432 6.26214 8.85124 6.27721 8.81483C6.29228 8.77842 6.30002 8.7394 6.3 8.7V7.5C6.30002 7.4606 6.29228 7.42158 6.27721 7.38517C6.26214 7.34876 6.24004 7.31568 6.21218 7.28782C6.18432 7.25996 6.15124 7.23786 6.11483 7.22279C6.07842 7.20772 6.0394 7.19998 6 7.2H5.4938C5.76578 6.83973 5.99035 6.446 6.162 6.0285C6.22488 6.03385 6.28774 6.0378 6.35038 6.0378C6.89805 6.03245 7.4266 5.83574 7.84452 5.48174C8.20471 5.17588 8.49446 4.79573 8.69391 4.36735C8.89336 3.93898 8.99778 3.47252 9 3V1.8C9.00002 1.7606 8.99228 1.72158 8.97721 1.68517C8.96214 1.64876 8.94004 1.61568 8.91218 1.58782C8.88432 1.55996 8.85124 1.53786 8.81483 1.52279C8.77842 1.50772 8.7394 1.49998 8.7 1.5ZM1.53574 5.01768C1.2454 4.76713 1.01178 4.45759 0.85043 4.10968C0.68908 3.76177 0.603709 3.38348 0.6 3V2.1H1.71656C1.86724 2.92558 2.06322 3.74224 2.30361 4.54629C2.40077 4.86709 2.50003 5.16138 2.60089 5.43516C2.20935 5.41806 1.83462 5.27118 1.53574 5.01768ZM5.7 7.8V8.4H3.3V7.8H5.7ZM8.4 3C8.39629 3.38348 8.31092 3.76177 8.14957 4.10968C7.98822 4.45759 7.7546 4.76713 7.46426 5.01768C7.16537 5.27092 6.79073 5.41753 6.39935 5.43443C6.50012 5.16094 6.5993 4.8668 6.69639 4.54629C6.93678 3.74224 7.13276 2.92558 7.28344 2.1H8.4V3Z" fill="white"/>
				</g>
				<defs>
					<clipPath id="clip0_22358_39385">
						<rect width="9" height="9" fill="white"/>
					</clipPath>
				</defs>
			</svg>
		</div>
		<div class="absolute h-[16px] -top-5 w-full text-zt-more uppercase text-xs flex justify-center items-center font-semibold"
         v-if="variant === 'third'">
			<span class="before:absolute before:h-[18px] before:bottom-[15px] before:left-1/2 before:border-r-[2px]
			             before:border-dotted before:border-[#3A4B64]">
				3 Miejsce
			</span>
		</div>
    <div class="flex bg-[#283344] z-50 pl-2 py-2.5 text-[13px] font-normal -leading-[0.195px]
		            gap-y-[1px] border border-zt-light rounded-zt justify-between basis-full xl:w-[294px]"
         :class="[{'!basis-2/3 space-x-5' : match?.date && isPlaceholder},
                  {'border-[2px] !border-zt-more' : isHighlighted}, {'xl:!w-[258px]': columnCount === 3}]">
      <div class="flex justify-center flex-col w-full">
        <div class="flex justify-between items-center h-[19.5px]">
          <div v-if="isPlaceholder" class="flex gap-x-[6px] items-center">
            <template v-if="match?.top_team?.length > 0">
              <img :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${match?.localteam_team_query_name}.png`"
                   :class="{'object-contain h-[17px] w-[17px]' : match.country_query_name !== 'swiat'}"
                   width="17" height="17" :alt="match?.top_team"/>
              <div class="line-clamp-1 text-ellipsis break-all !max-w-full pr-2">
                {{ match?.top_team }}
              </div>
            </template>
            <div v-else>
              <img :src="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
                   width="17" height="14" alt="" class="inline">
              {{ match.top_text }}
            </div>
          </div>
          <div v-else-if="match.localteam_id !== '0' && unknownTeamId !== match.localteam_id"
               class="flex gap-x-[6px] items-center">
            <img v-if="match.localteam_team_query_name" :class="{'object-contain h-[17px] w-[17px]' : match.country_query_name !== 'swiat'}"
                 :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${match.localteam_team_query_name}.png`"
                 width="17" height="17" :alt="match.localteam_name"/>
            <div class="line-clamp-1 text-ellipsis max-w-[140px] break-all"
                 :class="{ '!max-w-full pr-2' : !hasMatchStarted, 'font-semibold' : getFinalMatchResult > 0 &&
                 !(penaltyShootoutOccurred || penaltyShootoutOccurredInSecondMatch || match.status === 'AET') && !isSeeded }">
              {{ match.localteam_shortname?.length > 0 ? match?.localteam_shortname : match.localteam_name }}
            </div>
            <span v-if="getFinalMatchResult > 0 && variant !== 'final' && variant !== 'third'">
              <img data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-delay="1000" title="Awans"
                   class="inline -translate-y-[1px] transform-gpu"
                   :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/promotion.svg`"
                   width="10" height="10" alt="Awans" />
	          </span>
            <span v-if="(penaltyShootoutOccurred || penaltyShootoutOccurredInSecondMatch || match.status === 'AET') && getFinalMatchResult > 0"
                  class="text-[10px] text-zt-more">
                  ({{match.status === 'AET' ? 'Dogr.' : 'Karne'}})
            </span>
          </div>
          <div class="flex gap-x-[14px] pr-2.5 font-['Lato']" v-if="hasMatchStarted">
            <div v-if="!isSeeded">
              {{ localTeamStat }}
            </div>
            <div v-if="!isSeeded && secondMatchStarted">
              {{ secondMatchLocalTeamStat }}
            </div>
          </div>
        </div>
        <div class="flex justify-between items-center h-[19.5px]">
          <div v-if="isPlaceholder" class="flex gap-x-[6px] items-center">
            <template v-if="match?.bottom_team?.length > 0">
              <img :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${match?.visitorteam_team_query_name}.png`"
                   :class="{'object-contain h-[17px] w-[17px]' : match.country_query_name !== 'swiat'}"
                   width="17" height="17" :alt="match?.bottom_team"/>
              <div class="line-clamp-1 text-ellipsis break-all !max-w-full pr-2">
                {{ match?.bottom_team }}
              </div>
            </template>
            <div v-else>
              <img :src="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
                   width="17" height="14" alt="" class="inline">
              {{ match.bottom_text }}
            </div>
          </div>
          <div v-else-if="unknownTeamId !== match.visitorteam_id" class="flex gap-x-[6px] items-center">
            <img v-if="!isSeeded && match.visitorteam_team_query_name"
                 :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${match.visitorteam_team_query_name}.png`"
                 :class="{'object-contain h-[17px] w-[17px]' : match.country_query_name !== 'swiat'}"
                 width="17" height="17" :alt="match.visitorteam_name"/>
            <div class="line-clamp-1 text-ellipsis max-w-[140px] break-all"
                 :class="{ 'font-semibold' : getFinalMatchResult < 0 && !isSeeded &&
                 !(penaltyShootoutOccurred || penaltyShootoutOccurredInSecondMatch || match.status === 'AET'),
                 '!max-w-full pr-2' : !hasMatchStarted }">
              {{ isSeeded ? '': match.visitorteam_shortname?.length ? match?.visitorteam_shortname : match.visitorteam_name }}
            </div>
            <span v-if="getFinalMatchResult < 0 && variant !== 'final' && variant !== 'third'">
              <img data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-delay="1000" title="Awans"
                   class="inline -translate-y-[1px] transform-gpu"
                   :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/promotion.svg`"
                   width="10" height="10" alt="Awans" />
	          </span>
            <span v-if="(penaltyShootoutOccurred || penaltyShootoutOccurredInSecondMatch || match.status === 'AET') && getFinalMatchResult < 0"
                  class="text-[10px] text-zt-more">
                  ({{match.status === 'AET' ? 'Dogr.' : 'Karne'}})
            </span>
          </div>
          <div class="flex gap-x-[14px] justify-between pr-2.5 font-['Lato']" v-if="hasMatchStarted">
            <div v-if="!isSeeded">
              {{ visitorTeamStat }}
            </div>
            <div v-if="!isSeeded && secondMatchStarted">
              {{ secondMatchVisitorTeamStat }}
            </div>
          </div>
        </div>
      </div>
      <div class="basis-1/3 text-center justify-self-end text-zt-more text-xs flex flex-col justify-center items-center"
           v-if="match?.date && (isPlaceholder || ['NS', 'TBD'].includes(match.status)) && !(formatTime(match.date).includes('01:00'))">
        <div class="h-[19.5px]"> {{ formatDate(match.date) }}</div>
        <div v-if="isValidHour" class="h-[19.5px]"> {{ formatTime(match.date) }}</div>
      </div>
    </div>
	</a>
</template>

<script>
export default {
	name: 'LadderMatch',
  inject: ['WP'],
	props: ['match', 'variant', 'league_id', 'columnCount'],
	computed: {
    isValidHour() {
      const date = DateTime.fromSQL(this.match.date);
      const hour = date.toFormat('H:mm');

      const exceptions = [253, 307, 9, 913, 15, 1, 100011, 480, 6];

      if (exceptions.includes(+this.leagueId)) {
        return true;
      }
      return hour !== '1:00' && hour !== '2:00' && hour !== '0:00';
    },
		secondMatch() {
			return this.match?.match_2 ?? false;
		},
		isSeeded() {
			return this.match.status === 'SEED';
		},
		isNext() {
			return this.match.status === 'NEXT';
		},
		leagueId() {
			return this.match.league_id;
		},
		unknownTeamId() {
			return this.match?.unknown_team;
		},
		secondMatchStarted() {
			if (!this.secondMatch) {
				return false;
			}
			return ['FT', 'PEN', 'AET', '1H', 'HT', '2H', 'ET'].includes(this.secondMatch.status);
		},
		isPlaceholder() {
			return this.match.status === 'PLACEHOLDER';
		},
		penaltyShootoutOccurred() {
			return this.match.localteam_penalty_shootout && this.match.visitorteam_penalty_shootout &&
				(this.match.localteam_penalty_shootout !== '0' || this.match.visitorteam_penalty_shootout !== '0');
		},
		penaltyShootoutOccurredInSecondMatch() {
			if (!this.secondMatch) {
				return false;
			}
			return this.secondMatch.localteam_penalty_shootout && this.secondMatch.visitorteam_penalty_shootout &&
				(this.secondMatch.localteam_penalty_shootout !== '0' || this.secondMatch.visitorteam_penalty_shootout !== '0');
		},
		getResult() {
			if (this.penaltyShootoutOccurred && !this.secondMatch) {
				return +this.match.localteam_penalty_shootout - +this.match.visitorteam_penalty_shootout;
			}
			return +this.match.localteam_goals - +this.match.visitorteam_goals;
		},
		getFinalMatchResult() {
			let currentResult = this.getResult;
			if (!this.secondMatch) {
				return currentResult;
			}
      if (!['FT', 'PEN', 'AET'].includes(this.secondMatch.status)) {
        return 0;
      }
			if (this.penaltyShootoutOccurredInSecondMatch) {
				return +this.secondMatch.localteam_penalty_shootout - +this.secondMatch.visitorteam_penalty_shootout;
			}
			if (this.leagueId === 45) {
				return +this.secondMatch.localteam_goals - +this.secondMatch.visitorteam_goals;
			} else {
				currentResult += +this.secondMatch.localteam_goals - +this.secondMatch.visitorteam_goals;
				return currentResult;
			}
		},
		localTeamStat() {
			let stat = 0;
			if (this.penaltyShootoutOccurred && (+this.match.localteam_penalty_shootout > +this.match.visitorteam_penalty_shootout) && !this.secondMatch) {
				stat += 1;
			}
			stat += +this.match.localteam_goals;
			return stat;
		},
		visitorTeamStat() {
			let stat = 0;
			if (this.penaltyShootoutOccurred && (+this.match.visitorteam_penalty_shootout > +this.match.localteam_penalty_shootout) && !this.secondMatch) {
				stat += 1;
			}
			stat += +this.match.visitorteam_goals;
			return stat;
		},
		secondMatchLocalTeamStat() {
			let stat = 0;
			if (this.penaltyShootoutOccurredInSecondMatch && (+this.secondMatch.localteam_penalty_shootout > +this.secondMatch.visitorteam_penalty_shootout) && this.secondMatch) {
				stat += 1;
			}
			stat += +this.secondMatch.localteam_goals;
			return stat;
		},
		secondMatchVisitorTeamStat() {
			let stat = 0;
			if (this.penaltyShootoutOccurredInSecondMatch && (+this.secondMatch.visitorteam_penalty_shootout > +this.secondMatch.localteam_penalty_shootout) && this.secondMatch) {
				stat += 1;
			}
			stat += +this.secondMatch.visitorteam_goals;
			return stat;
		},
		hasMatchStarted() {
			return ['FT', 'PEN', 'AET'].includes(this.match.status)
		},
    isHighlighted() {
      if (this.isPlaceholder) {
        let teamNameDetails = [this.WP.team?.name, this.WP.team?.team_short_name];
        return teamNameDetails.includes(this.match?.bottom_team) || teamNameDetails.includes(this.match?.top_team)
      } else  {
        return this.WP.team?.team_id === this.match.localteam_id || this.WP.team?.team_id === this.match.visitorteam_id;
      }
    },
	},
  methods: {
    formatDate(dateString) {
      if (dateString.includes('-')) {
        const [date, time] = dateString.split(' ');
        const [year, month, day] = date.split('-');
        return `${day}.${month}`;
      } else {
        const [date, time] = dateString.split(' ');
        return date;
      }
    },
    formatTime(dateString) {
      if (dateString.includes('-')) {
        const [date, time] = dateString.split(' ');
        return time.substring(0, 5);
      } else {
        const [date, time] = dateString.split(' ');
        return time;
      }
    },
    handleClick(link, target) {
      if (link !== null) {
        if (this.WP.id === 5) {
          countClicks('Strona główna - drabinka (kliki w MECZE)').then(() => {
            if (target !== '_blank') {
              window.location.href = link;
            }
          });
        } else {
          if (target !== '_blank') {
            window.location.href = link;
          }
        }
        if (target === '_blank') {
          window.open(link, target);
        }
      }
    }
  }
}
</script>